import Phaser from "phaser";
import { cst } from "../helpers/cst.js";
import buttonBehaviours from "../helpers/button-behaviours.js";

export default class Pause extends Phaser.Scene {
  constructor() {
    super(cst.scenes.pause);
  }

  preload() {}

  create(data) {
    this.scene.bringToTop();
    this.oldScene = data.scene;
    const soundTexture = !this.sound.mute ? "btn-sound-on" : "btn-sound-off";

    this.background = this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "bg-overlay",
    );

    this.btnMenu = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 250,
        "btn-home",
      )
      .setScale(0.8)
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnMenu, () => {
          this.oldScene.events.off("resume");
          this.scene.stop(cst.scenes.board);
          this.scene.stop();
          this.scene.start(cst.scenes.menu);
        });
      });

    this.btnSound = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2,
        soundTexture,
      )
      .setScale(0.8)
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnSound, () => {
          this.sound.mute
            ? (this.sound.mute = false)
            : (this.sound.mute = true);
          this.sound.mute
            ? this.btnSound.setTexture("btn-sound-on")
            : this.btnSound.setTexture("btn-sound-off");
        });
      });

    this.btnBack = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 + 250,
        "btn-back",
      )
      .setScale(1.6)
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnBack, () => {
          this.scene.stop();
          this.scene.resume(this.oldScene, {
            scene: cst.scenes.pause,
          });
        });
      });
  }
}
